import { observer } from 'mobx-react';

import { useClaimLicenseBannerDisplayQuery } from 'hooks/query-hooks/claim-license/useClaimLicenseQuery';
import { useCurrentUserQuery } from 'hooks/query-hooks/users/useUserQuery';

import { CAN_MANAGE_CLAIM_LICENSE, CLAIMS_USERS } from 'utils/constants';
import { PANEL_MENU_ITEMS } from 'utils/constants';

import ExpiredLicenseBanner from 'components/pages/claim-license/ExpiredLicenseBanner';
import ButtonGrid from 'components/pages/home/ButtonGrid';

const PanelHomePage = () => {
  const { data: user } = useCurrentUserQuery();
  const canViewLicenseBanner = Boolean(
    user?.groups?.includes(CLAIMS_USERS) || user?.groups?.includes(CAN_MANAGE_CLAIM_LICENSE),
  );
  const { data: bannerData } = useClaimLicenseBannerDisplayQuery(user?.pk, {
    enabled: canViewLicenseBanner && Boolean(user?.pk),
  });

  const buttonsToShow = PANEL_MENU_ITEMS.filter(
    item => !item.permissions || user.groups.some(i => item.permissions.includes(i)),
  );

  return (
    <>
      {canViewLicenseBanner && bannerData && (
        <ExpiredLicenseBanner
          bannerData={bannerData}
          canViewLicenseBanner={canViewLicenseBanner}
          isClaimsManager={user?.groups?.includes(CAN_MANAGE_CLAIM_LICENSE)}
        />
      )}
      <ButtonGrid
        title="MLP Panel Department Homepage"
        bigButtons={buttonsToShow.filter(item => item.style === 'big')}
        smallButtons={buttonsToShow.filter(item => item.style === 'small')}
      />
    </>
  );
};

export default observer(PanelHomePage);
